import AppAnnieSvg from '@gp/assets/svg/datasource-icon/AppAnnie.svg';
import MScienceSvg from '@gp/assets/svg/datasource-icon/MScience.svg';
import NewzooSvg from '@gp/assets/svg/datasource-icon/Newzoo.svg';
import AppAnnieSvgBubble from '@gp/assets/svg/datasource-icon/app-annie.svg';
import MScienceSvgBubble from '@gp/assets/svg/datasource-icon/mscience-bg.svg';
import NewzooSvgBubble from '@gp/assets/svg/datasource-icon/newzoo-bg.svg';

/**
 * 公用表头的配置
 */
const TABLE_COMMON_COL_HEADER_MAP: CommonColHeaderItemType[] = [
  /**Total Revenue */
  {
    keyName: 'total_revenue',
    platform: 'all platforms',
    resKeyName: [],
    title: '<time> Total\nRevenue($)(MoM)', // <time>表示这个槽位取后端对应字段数据，\n表示换行展示
    width: 220,
    isGroup: true,
    groupKey: '',
    metric: 'revenue',
    dataSource: '',
  },
  {
    keyName: 'mobile_revenue',
    platform: 'mobile',
    resKeyName: [],
    title: '<time> Revenue\nMobile($)(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_revenue',
    metric: 'revenue',
    dataSource: 'app annie',
  },
  {
    keyName: 'pc_revenue',
    platform: 'pc',
    resKeyName: [],
    title: '<time> Revenue\nPC($)(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_revenue',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  {
    keyName: 'console_revenue',
    platform: 'console',
    resKeyName: [],
    title: '<time> Revenue\nConsole($)(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_revenue',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  /**Total Revenue Target */
  {
    keyName: 'total_revenue_target',
    platform: 'all platforms',
    resKeyName: [],
    title: '<time> Total\nRevenue Target($)(MoM)',
    width: 260,
    isGroup: true,
    groupKey: '',
    metric: 'revenue',
    dataSource: '',
  },
  {
    keyName: 'mobile_revenue_target',
    platform: 'mobile',
    resKeyName: [],
    title: '<time> Revenue Target\nMobilie($)(MoM)',
    width: 280,
    isGroup: false,
    groupKey: 'total_revenue_target',
    metric: 'revenue',
    dataSource: 'app annie',
  },
  {
    keyName: 'pc_revenue_target',
    platform: 'pc',
    resKeyName: [],
    title: '<time> Revenue Target\nPC($)(MoM)',
    width: 280,
    isGroup: false,
    groupKey: 'total_revenue_target',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  {
    keyName: 'console_revenue_target',
    platform: 'console',
    resKeyName: [],
    title: '<time> Revenue Target\nConsole($)(MoM)',
    width: 280,
    isGroup: false,
    groupKey: 'total_revenue_target',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  /**YTM Total Revenue */
  {
    keyName: 'ytm_total_revenue',
    platform: 'all platforms',
    resKeyName: [],
    title: 'YTM Total\nRevenue($)(YoY)',
    width: 220,
    isGroup: true,
    groupKey: '',
    metric: 'revenue',
    dataSource: '',
  },
  {
    keyName: 'ytm_mobile_revenue',
    platform: 'mobile',
    resKeyName: [],
    title: 'YTM Revenue\nMobile($)(YoY)',
    width: 220,
    isGroup: false,
    groupKey: 'ytm_total_revenue',
    metric: 'revenue',
    dataSource: 'app annie',
  },
  {
    keyName: 'ytm_pc_revenue',
    platform: 'pc',
    resKeyName: [],
    title: 'YTM Revenue\nPC($)(YoY)',
    width: 220,
    isGroup: false,
    groupKey: 'ytm_total_revenue',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  {
    keyName: 'ytm_console_revenue',
    platform: 'console',
    resKeyName: [],
    title: 'YTM Revenue\nConsole($)(YoY)',
    width: 220,
    isGroup: false,
    groupKey: 'ytm_total_revenue',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  /**YTM Total Revenue Target */
  {
    keyName: 'ytm_total_revenue_target',
    platform: 'all platforms',
    resKeyName: [],
    title: 'YTM Total\nRevenue Target($)(YoY)',
    width: 260,
    isGroup: true,
    groupKey: '',
    metric: 'revenue',
    dataSource: '',
  },
  {
    keyName: 'ytm_mobile_revenue_target',
    platform: 'mobile',
    resKeyName: [],
    title: 'YTM Revenue Target\nMobile($)(YoY)',
    width: 250,
    isGroup: false,
    groupKey: 'ytm_total_revenue_target',
    metric: 'revenue',
    dataSource: 'app annie',
  },
  {
    keyName: 'ytm_pc_revenue_target',
    platform: 'pc',
    resKeyName: [],
    title: 'YTM Revenue Target\nPC($)(YoY)',
    width: 250,
    isGroup: false,
    groupKey: 'ytm_total_revenue_target',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  {
    keyName: 'ytm_console_revenue_target',
    platform: 'console',
    resKeyName: [],
    title: 'YTM Revenue Target\nConsole($)(YoY)',
    width: 250,
    isGroup: false,
    groupKey: 'ytm_total_revenue_target',
    metric: 'revenue',
    dataSource: 'mscience',
  },
  /**Total MAU */
  {
    keyName: 'total_mau',
    platform: 'all platforms',
    resKeyName: [],
    title: '<time> Total\nMAU(MoM)',
    width: 220,
    isGroup: true,
    groupKey: '',
    metric: 'mau',
    dataSource: '',
  },
  {
    keyName: 'mobile_mau',
    platform: 'mobile',
    resKeyName: [],
    title: '<time> MAU\nMobile(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_mau',
    metric: 'mau',
    dataSource: 'app annie',
  },
  {
    keyName: 'pc_mau',
    platform: 'pc',
    resKeyName: [],
    title: '<time> MAU\nPC(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_mau',
    metric: 'mau',
    dataSource: 'newzoo',
  },
  {
    keyName: 'console_mau',
    platform: 'console',
    resKeyName: [],
    title: '<time> MAU\nConsole(MoM)',
    width: 220,
    isGroup: false,
    groupKey: 'total_mau',
    metric: 'mau',
    dataSource: 'newzoo',
  },
];

// 有排序的列
const TABLE_SORT_KEY: string[] = [
  'projects',
  'total_revenue',
  'mobile_revenue',
  'pc_revenue',
  'console_revenue',
  'total_revenue_target',
  'mobile_revenue_target',
  'pc_revenue_target',
  'console_revenue_target',
  'ytm_total_revenue',
  'ytm_mobile_revenue',
  'ytm_pc_revenue',
  'ytm_console_revenue',
  'ytm_total_revenue_target',
  'ytm_mobile_revenue_target',
  'ytm_pc_revenue_target',
  'ytm_console_revenue_target',
  'total_mau',
  'mobile_mau',
  'pc_mau',
  'console_mau',
];
// 默认收起子列
const TABLE_SUB_KEY: string[] = [
  'mobile_revenue',
  'pc_revenue',
  'console_revenue',
  'mobile_revenue_target',
  'pc_revenue_target',
  'console_revenue_target',
  'ytm_mobile_revenue',
  'ytm_pc_revenue',
  'ytm_console_revenue',
  'ytm_mobile_revenue_target',
  'ytm_pc_revenue_target',
  'ytm_console_revenue_target',
  'mobile_mau',
  'pc_mau',
  'console_mau',
];

// 数据源icon及气泡配置，键名对应上面的metric和dataSource
const DATA_SOURCE_MAP: any = {
  bubblesvg: {
    'app annie': AppAnnieSvgBubble,
    mscience: MScienceSvgBubble,
    newzoo: NewzooSvgBubble,
  },
  svg: {
    'app annie': AppAnnieSvg,
    mscience: MScienceSvg,
    newzoo: NewzooSvg,
  },
  metric: {
    revenue: 'Revenue',
    mau: 'MAU',
  },
  name: {
    'app annie': 'App Annie',
    mscience: 'Mscience',
    newzoo: 'Newzoo',
  },
};

export {
  TABLE_COMMON_COL_HEADER_MAP,
  TABLE_SUB_KEY,
  TABLE_SORT_KEY,
  DATA_SOURCE_MAP,
};
